import {
  AgxColumn,
  AgxRow,
  AgxTypography,
  AgxDivider,
  AgxToggleSwitch,
  AgxNotificationBox,
} from '@urbanx/agx.ui-components2'
import AgreementDetailsComponent from './AgreementDetails'
import { TaskStepDto } from '@urbanx/agx.activities.client'
import { ListingAgreementDetails } from '@urbanx/agx.campaigns.client'

export const QLDAgreementTypeStageSteps = ({
  agreementDetails,
  onAgreementDetailsUpdated,
  isOpen,
  exceededGap,
  tasksStage2,
  updateTaskStep2,
}: {
  agreementDetails?: ListingAgreementDetails
  onAgreementDetailsUpdated: (updated: {
    id: string
    value: ListingAgreementDetails
  }) => void
  isOpen: boolean
  exceededGap: boolean
  tasksStage2: TaskStepDto[]
  updateTaskStep2: (step: TaskStepDto, isChecked: boolean) => void
}) => {
  const signatureTask = tasksStage2[tasksStage2.length - 1]

  return (
    <AgxColumn gap="spacing-xl" fill>
      {agreementDetails && (
        <>
          <AgreementDetailsComponent
            id="agreementDetails"
            value={agreementDetails}
            onValueChange={onAgreementDetailsUpdated}
          />
          {isOpen === false && exceededGap && (
            <AgxNotificationBox
              type="danger"
              heading=""
              body="Appointment period exceeds 90 days"
            />
          )}
        </>
      )}

      <AgxDivider variant="horizontal" />

      {signatureTask && (
        <>
          <AgxTypography size="large" type="title" id="modalTitle">
            Part 6 Signatures
          </AgxTypography>

          <AgxRow
            gap="spacing-lg"
            justifyContent="space-between"
            alignItems="flex-start"
            fill
            key={'stage2rows'}
          >
            <AgxRow  justifyContent="left" alignItems="flex-start">
              <AgxTypography
                id={'lbllicenseeDetails'}
                type={'body_ui'}
                size={'small'}
              >
                {signatureTask.name}
              </AgxTypography>
            </AgxRow>

            <AgxRow  justifyContent="right" alignItems="flex-start">
              <AgxToggleSwitch
                id="step"
                checked={signatureTask.isCompleted ?? false}
                onChange={(isChecked: boolean) =>
                  updateTaskStep2(signatureTask, isChecked)
                }
              />
            </AgxRow>
          </AgxRow>

          <AgxDivider variant="horizontal" />
        </>
      )}
    </AgxColumn>
  )
}

export default QLDAgreementTypeStageSteps
